import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { TmpI18NService } from 'app/i18n/tmp-i18n.service';
import { IntercomService } from 'app/intercom/intercom.service';

@Component({
  selector: 'cc-limit-reached-list-state',
  templateUrl: './limit-reached-list-state.component.html',
  styleUrls: ['./limit-reached-list-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LimitReachedListStateComponent implements OnInit {
  upgradePlanText: string;

  constructor(
    private readonly intercomService: IntercomService,
    protected readonly i18nService: TmpI18NService,
  ) {}

  ngOnInit() {
    this.upgradePlanText = this.i18nService.getMessage('upgradePlanToUnlockLimit');
  }

  openLiveChat() {
    this.intercomService.open();
  }
}
